import script from "./Delegator.vue?vue&type=script&setup=true&lang=js"
export * from "./Delegator.vue?vue&type=script&setup=true&lang=js"

import "./Delegator.vue?vue&type=style&index=0&id=4526a194&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4526a194"]])

export default __exports__